var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF31FF",
    d: "M6.643 7.714a1.071 1.071 0 1 0 0-2.143a1.071 1.071 0 0 0 0 2.143m10.714 0a1.071 1.071 0 1 0 0-2.143a1.071 1.071 0 0 0 0 2.143m0 10.286a1.071 1.071 0 1 0 0-2.143a1.071 1.071 0 0 0 0 2.143m-10.714.428a1.071 1.071 0 1 0 0-2.142a1.071 1.071 0 0 0 0 2.142m8.725-2.142a.91.91 0 0 1-.762-.408a1 1 0 0 1-.129-.278a2.571 2.571 0 0 0-4.959 0a.94.94 0 0 1-.325.493a.88.88 0 0 1-.557.193H8.63a.917.917 0 0 1-.51-1.68q.13-.084.279-.129a2.576 2.576 0 0 0 0-4.959a.94.94 0 0 1-.493-.325a.9.9 0 0 1-.193-.557V8.63a.917.917 0 0 1 1.68-.51q.084.13.129.279a2.576 2.576 0 0 0 4.958 0a.94.94 0 0 1 .326-.493a.88.88 0 0 1 .557-.193h.004a.917.917 0 0 1 .51 1.68q-.13.084-.278.129a2.571 2.571 0 0 0 0 4.958a.94.94 0 0 1 .493.326a.88.88 0 0 1 .193.557v.004a.917.917 0 0 1-.918.918M12 13.07a1.072 1.072 0 1 0 0-2.143a1.072 1.072 0 0 0 0 2.143"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXeta);
export default __webpack_public_path__ + "static/media/xeta.2cbafa4130023447c43f51c64e5500c9.svg";
export { ForwardRef as ReactComponent };